import { render, staticRenderFns } from "./ProjectEditAxes.vue?vue&type=template&id=29bd5ec8&"
import script from "./ProjectEditAxes.vue?vue&type=script&lang=js&"
export * from "./ProjectEditAxes.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEditAxes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports